module.exports = __webpack_public_path__ + "media/images/countryrect/tamil-ac8ac68716d468c8770c60c78a7f609c.svg";